<template>
  <div>
    <fcc-botoes-navegacao left @anterior="$emit('anterior')" />

    <fcc-table
      striped
      hover
      responsive
      pagination
      :items="lista"
      :fields="fields"
      @row-selected="selecionaItens"
    />
  </div>
</template>
<script>
import fccBotoesNavegacao from './fccBotoesNavegacao.vue'

export default {
  components: { fccBotoesNavegacao },
  props: {
    lista: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      fields: [
        {
          type: 'rowSelect',
          key: 'rowSelect',
          active: true
        },
        { key: 'uf', label: 'UF', sortable: true },
        { key: 'cidade', label: 'Cidade', sortable: true },
        { key: 'periodo', label: 'Período', sortable: true },
        { key: 'horaapres', label: 'Hora Apres.', sortable: true },
        { key: 'codvirtual', label: 'Cod. VIrtual', sortable: true },
        { key: 'colegio', label: 'Colégio', sortable: true }
      ]
    }
  },
  methods: {
    selecionaItens(itens) {
      this.$emit(
        'seleciona-itens',
        itens
          .map((item) => item.iddatacolegio)
          .reduce((acc, curr) => curr + (acc ? `,${acc}` : ''), '')
      )
    }
  }
}
</script>